<template>
  <div>
    <validation-provider
      #default="validationContext"
      :name="name"
      :rules="validations"
    >
      <quill-editor
        v-b-tooltip.hover.bottomleft="tooltip != null ? tooltip : ''"
        v-model="content"
        :options="snowOption"
      />
      <b-form-invalid-feedback :state="getValidationState(validationContext)">
        {{ validationContext.errors[0] }}
      </b-form-invalid-feedback>
    </validation-provider>
  </div>
</template>

<script>
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import {
  BRow,
  BCol,
  BCard,
  BCardBody,
  BFormDatepicker,
  BForm,
  VBTooltip,
  BFormGroup,
  BFormTextarea,
  BFormInput,
  BFormCheckbox,
  BFormInvalidFeedback,
  BButton,
} from "bootstrap-vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required, amount } from "@validations";
import { ref, onUnmounted } from "@vue/composition-api";
import formValidation from "@core/comp-functions/forms/form-validation";
import Ripple from "vue-ripple-directive";

import { quillEditor } from "vue-quill-editor";
import vSelect from "vue-select";
export default {
  props: [
    "name",
    "valuex",
    "keys",
    "label",
    "options",
    "tooltip",
    "id",
    "validations",
  ],
  components: {
    BCol,
    quillEditor,
    BCard,
    BRow,
    BForm,
    BCardBody,
    BFormGroup,
    BFormCheckbox,
    BFormTextarea,
    BFormInput,
    BFormInvalidFeedback,
    BButton,
    ValidationProvider,
    ValidationObserver,
    BFormDatepicker,
    vSelect,
  },
  directives: {
    Ripple,
    "b-tooltip": VBTooltip,
  },
  setup(props, { emit }) {
    const { refFormObserver, getValidationState } = formValidation();

    return {
      refFormObserver,
      getValidationState,
    };
  },
  data() {
    return {
      required,
      amount,
      content: "",
    };
  },
  watch: {
    content(old, to) {
      this.changevalue(this.content);
    },
  },
  mounted() {
    this.$watch(
      "$props",
      () => {
        if (
          (typeof this.valuex == "string" && this.valuex.length > 0) ||
          typeof this.valuex == "number"
        ) {
          this.content = this.getvalue(this.valuex, this.options);
          this.changevalue(this.content);
        }
      },
      { deep: true }
    );
    this.content = this.getvalue(this.valuex, this.options);
    this.changevalue(this.content);
  },
  methods: {
    getvalue(val, list) {
      for (var i = 0; i < list.length; i++) {
        if (list[i].id == val) {
          return list[i];
        }
      }
      return "";
    },
    changevalue(content) {
      if (content) {
        this.$emit("updatedata", content);
        this.content = content;
      }
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>
